import React from 'react'
import { IHRLocation } from '@api/types'
import HRLocationList from './HRLocationList'

interface MultiHRLocationListProps {
  values: IHRLocation[]
  onChange: (hrLocations: IHRLocation[]) => void
  cancelLocationFilter: () => void
}

export default function MultiHRLocationList({
  values,
  onChange,
  cancelLocationFilter,
}: MultiHRLocationListProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <HRLocationList
      multi
      value={null}
      itemDisabled={(item) => !!values.find(({ id }) => item.id === id)}
      values={values}
      onChange={(filteredLocs) => {
        onChange(filteredLocs)
      }}
      {...{ buttonProps }}
      cancelLocationFilter={cancelLocationFilter}
    />
  )
}
